import { Profile } from '../../features/profile/Services/ProfileService.ts';

export interface ProfileSlice {
    setProfile: (data: Profile) => void;
    profile: Profile;
}

export const createProfileSlice = (set) => ({
    profile: null,

    setProfile: (newProfile: Profile) => {
        set(() => ({
            profile: newProfile,
        }));
    },
});
